const calendarLang = {
}

export default {
  calendars: calendarLang
}
